import React from 'react';
import {Orders, Products} from 'api';
import {LoadingPage} from 'components/loading-page';
import {DateTime} from 'components/UI/DateTime';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import {numberFormat} from 'components/utils';
import {connect} from 'react-redux';

class ManageOrderDetailProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: null,
      totalPrice: 0,
      orderInfo: null,
      isLoading: false
    };
  }

  componentDidMount() {
    if (this.props.params && this.props.myBusinesses && this.props.params.id) {
      let params = {
        id: this.props.params.id,
        filter: {
          include: {
            relation: 'orderDetails',
            scope: {
              include: 'product'
            }
          }
        }
      };
      this.setState({isLoading: true});
      Orders.actions.order.request(params).then(response => {
        let products = [];
        let totalAmount = 0;
        let orderDetail = {
          name: response.data.customerName,
          phone: response.data.customerPhone,
          status: response.data.status
        };
        response.data.orderDetails.map((order, idx) => {
          if (order.product.businessId === this.props.myBusinesses.id) {
            products.push({
              ...order.product,
              count: order.quantity
            });
            totalAmount+= parseFloat(order.price) * order.quantity;
          }
        });
        this.setState({orderInfo: orderDetail, isLoading: false, totalPrice: totalAmount, data: products});
      }).catch((error) => {
        this.setState({isLoading: false});
        this.props.history.push('/my-business/orders');
        toastr.error('Lỗi!', 'Không tìm thấy đơn hàng này.');
      });
    }
  }

  render() {
    if (!this.state.data) {
      return null;
    }
    return (
      <div className="shopping-cart-container">
        <LoadingPage isShow={this.state.isLoading} />
        <div className='shopping-cart-left-content'>
          <div className='table-list-item-shopping'>
            <div className='table-list-item-header'>
              <p className='table-list-item-header-content'>Thông tin người đặt hàng</p>
            </div>
            <div className='table-list-item-body'>
              <div className="item-shopping">
                <p className='item-shopping-name'><strong>Họ tên</strong>: {this.state.orderInfo.name}</p>
              </div>
              <div className="item-shopping">
                <p className='item-shopping-name'><strong>Số điện thoại</strong>: {this.state.orderInfo.phone}</p>
              </div>
            </div>
          </div>
          <div className='table-list-item-shopping'>
            <div className='table-list-item-header'>
              <p className='table-list-item-header-content'>Thông tin sản phẩm</p>
              <p className='table-list-item-header-content'>Đơn giá</p>
              <p className='table-list-item-header-content'>Số lượng</p>
            </div>
            <div className='table-list-item-body'>
              {
                this.state.data.map((item, idx) => {
                  return (
                    <div className="item-shopping">
                      <div className='item-shopping-img-wrap'>
                        <UploadImage transform="crop" type="PRODUCT" width="119" height="83" image={item.images[item.images.length -1]} />
                      </div>
                      <p className='item-shopping-name'>{item.name}</p>
                      <div className='item-shopping-price-wrap'>
                        <p className='item-price'>{item.price} VNĐ</p>
                      </div>
                      <div className='item-shopping-count-wrap'>
                        <p className='item-unit'>{item.count} Cái</p>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
        <div className='shopping-cart-right-content'>
          <div className='shopping-order-container'>
            <div className='content-justify mb5'>
              <p className='shopping-order-title'>Tồng tiền</p>
              <p className='shopping-order-content-red'>{numberFormat(this.state.totalPrice, '.', '.', '.')} VNĐ</p>
            </div>
            <p className='shopping-order-content-desc'>(Đã bao gồm VAT)</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    myBusinesses: state.myBusinesses.mainBusiness
  };
};

export default withRouter(connect(mapStateToProps)(ManageOrderDetailProduct));



// WEBPACK FOOTER //
// ./components/my-business/sub-view/manage-order/ManageOrderDetailProduct.jsx